import React from "react";

const FeaturesSection = () => {
  const features = [
    {
      title: "Heavily paid job Opportunities",
      description:
        "Connect with thousands of marketplaces and start getting paid within a couple of clicks.",
      icon: "/assests/images/LandingPage/IP/cart.svg",
    },
    {
      title: "Dedicated Account Manager",
      description:
        "Offer your international clients a simple way to pay you with our Billing Service",
      icon: "/assests/images/LandingPage/IP/polygon.svg",
    },
    {
      title: "Get paid weekly",
      description:
        "Receive bank account numbers in EUR, USD, GBP & more and get paid as easily as having a local bank account",
      icon: "/assests/images/LandingPage/IP/wallet.svg",
    },
    {
      title: "Dashboard view",
      description:
        "Transfer your earnings to your local bank account at low rates or via ATM.",
      icon: "/assests/images/LandingPage/IP/dashboard.svg",
    },
    {
      title: "Zero Hidden Fees",
      description:
        "Pay the VAT authorities in the EU and UK with the GBP and EUR funds in your Payoneer account, for zero fees",
      icon: "/assests/images/LandingPage/IP/coins-hand.svg",
    },
    {
      title: "24×7 Support",
      description:
        "Leverage our network of integrated service providers to simplify your business, helping you grow globally.",
      icon: "/assests/images/LandingPage/IP/send.svg",
    },
  ];

  return (
    <div className="bg-white py-16 px-6 md:px-16">
      <div className="max-w-7xl mx-auto text-center">
        {/* Section Header */}
        <h3 className="text-sm uppercase tracking-widest text-gray-400">
          Packed with powerful features
        </h3>
        <h2 className="text-xl md:text-5xl font-bold mt-2">
          A whole lot more than just sending money.
        </h2>
      </div>

      {/* Feature Grid */}
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {features.map((feature, index) => (
          <div
            key={index}
            className="flex flex-col items-start bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
          >
            {/* Icon */}
            <div className="text-3xl text-blue-600 rounded-lg">
              <img src={feature.icon} alt={feature.title} className="w-8 h-8" />
            </div>
            {/* Title */}
            <h4 className="text-lg font-semibold mt-4">{feature.title}</h4>
            {/* Description */}
            <p className="text-gray-600 mt-2">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesSection;
